import React from "react";

export const PaziaErrorMessage = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element | null => {
  return <p className="text-red-500 mt-1 text-sm text-end">{children}</p>;
};
